/**
 * 비밀번호 규칙 — 서버 `server/src/domain/password-policy.ts` 의 사본이다.
 *
 * 화면은 서버 왕복 없이 같은 판정을 먼저 보여 주고, 서버는 요청을 받을 때 다시 본다
 * (화면 검증만 믿지 않는다). 한쪽을 고치면 다른 쪽도 고칠 것.
 */

export const PASSWORD_MIN_LENGTH = 10
export const PASSWORD_MAX_LENGTH = 200

export type PasswordProblem =
  | "PASSWORD_TOO_SHORT"
  | "PASSWORD_TOO_LONG"
  | "PASSWORD_CONFIRM_MISMATCH"
  | "PASSWORD_SAME_AS_CURRENT"

export type NewPasswordInput = {
  currentPassword: string
  newPassword: string
  newPasswordConfirm: string
}

export function checkNewPassword(input: NewPasswordInput): PasswordProblem | null {
  const { currentPassword, newPassword, newPasswordConfirm } = input

  if (newPassword.length < PASSWORD_MIN_LENGTH) return "PASSWORD_TOO_SHORT"
  if (newPassword.length > PASSWORD_MAX_LENGTH) return "PASSWORD_TOO_LONG"
  if (newPassword !== newPasswordConfirm) return "PASSWORD_CONFIRM_MISMATCH"
  if (newPassword === currentPassword) return "PASSWORD_SAME_AS_CURRENT"

  return null
}

/** 세 칸이 다 차기 전에는 오류를 먼저 띄우지 않는다(입력 중에 빨간 글씨가 깜빡이지 않게). */
export function isFilled(input: NewPasswordInput): boolean {
  return (
    input.currentPassword.length > 0 &&
    input.newPassword.length > 0 &&
    input.newPasswordConfirm.length > 0
  )
}
